import { render, staticRenderFns } from "./EModalPlanoBimestral.vue?vue&type=template&id=9715d64c"
import script from "./EModalPlanoBimestral.vue?vue&type=script&lang=js"
export * from "./EModalPlanoBimestral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports